import React, { useContext, useEffect, useState } from 'react';
import Application from '../../../StateContext/Application';

const AddProduct = () => {
    const statecalls = useContext(Application);
    const { AddProduct } = statecalls;

    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        ProductName: '',
        PartCode: '',
        BinNumbers: '',
        Size: '',
        MinStockLevel: '',
        MaxStockLevel: '',
        UOM: '',
    });
    const [editId, setEditId] = useState(null);

    const getAllData = async () => {
        const response = await AddProduct("get");
        if (response && Array.isArray(response)) {
            setData(response);
            console.log("Set data:", response);
        } else {
            setData([]);
        }
    };

    useEffect(() => {
        getAllData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const Submit = async (e) => {
        e.preventDefault();
        console.log("Form submitted", formData);

        if (editId) {
            const response = await AddProduct("update", { ID: editId, ...formData });
            console.log("Update response:", response);
            if (response?.message === "success") {
                getAllData();
                setFormData({
                    ProductName: '',
                    PartCode: '',
                    BinNumbers: '',
                    Size: '',
                    MinStockLevel: '',
                    MaxStockLevel: '',
                    UOM: '',
                });
                setEditId(null);
            }
        } else {
            const response = await AddProduct("insert", formData);
            console.log("Insert response:", response);
            if (response?.message === "success") {
                getAllData();
                setFormData({
                    ProductName: '',
                    PartCode: '',
                    BinNumbers: '',
                    Size: '',
                    MinStockLevel: '',
                    MaxStockLevel: '',
                    UOM: '',
                });
            }
        }
    };

    const handleEdit = (item) => {
        setFormData({
            ProductName: item.Product_Name,
            PartCode: item.Part_Code,
            BinNumbers: item.Bin_Location,
            Size: item.Size,
            MinStockLevel: item.Min_Stock_Level,
            MaxStockLevel: item.Max_Stock_Level,
            UOM: item.UOM,
        });
        setEditId(item.ID);
        console.log("edit id", item.ID);
    };
    const handleDelete = async (e, ID) => {
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete?")) {
            const response = await AddProduct("delete", { ID });
            if (response?.message === "success") {
                getAllData();
            }
        }
    };
    return (
        <div>
            <form onSubmit={Submit} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{marginTop: 20,display: 'grid',gap: '2rem',width: '40vw',boxShadow: '0px 0px 10px',padding: '30px',backgroundColor: 'white',borderRadius: '10px'}}>
                    <h5>{editId ? "Edit Product" : "Add Product"}</h5>
                    <div style={{ display: 'grid', gap: '20px' }}>
                        <div style={{ display: 'flex' }} className="col-12">
                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>Product Name</label>
                            <input type="text" className="form-control" name="ProductName" value={formData.ProductName} onChange={handleChange} placeholder="Enter Product Name Here" />
                            
                        </div>
                        <div style={{ display: 'flex' }} className="col-12">
                            <label className="form-label" style={{ fontWeight: '700', width: '11rem' }}>Part Code</label>
                            <input type="text" name="PartCode" value={formData.PartCode} onChange={handleChange} className="form-control" placeholder="Enter Part Code Here" />
                        </div>
                        <div style={{ display: 'flex' }} className="col-12">
                            <label className="form-label" style={{ fontWeight: '700', width: '11rem' }}>Bin Location</label>
                            <input type="text" name="BinNumbers" value={formData.BinNumbers} onChange={handleChange} className="form-control" placeholder="Enter Bin Numbers Here" />
                        </div>
                        <div style={{ display: 'flex' }} className="col-12">
                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>Size</label>
                            <input type="text" className="form-control" name="Size" value={formData.Size} onChange={handleChange} />
                        </div>
                        <div style={{ display: 'flex' }} className="col-12">
                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>Min Stock Level</label>
                            <input type="number" className="form-control" name="MinStockLevel" value={formData.MinStockLevel} onChange={handleChange} />
                        </div>
                        <div style={{ display: 'flex' }} className="col-12">
                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>Max Stock Level</label>
                            <input type="number" className="form-control" name="MaxStockLevel" value={formData.MaxStockLevel} onChange={handleChange} />
                        </div>
                        <div style={{ display: 'flex' }} className="col-12">
                            <label className='form-label' style={{ fontWeight: '700', width: '11rem' }}>UOM (unit of measurement)</label>
                            <input type="text" className="form-control" name="UOM" value={formData.UOM} onChange={handleChange} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <button style={{ backgroundColor: 'red', width: '6rem', height: '2rem', color: 'white', border: 'none', borderRadius: '5px' }} type="submit">
                            Submit
                        </button>
                    </div>
                </div>
            </form>

            <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px" }}>
                <div style={{ display: 'flex', justifyContent: 'center', width: '70vw' }}>
                    <table style={{ backgroundColor: '#e8f7f3', width: '100%', borderRadius: '10px', overflow: 'hidden' }}>
                        <thead>
                            <tr style={{backgroundColor: '#ece9fe',color: 'black',height: '2.5rem'}}>
                                <th>Sr.No</th>
                                <th>Product Name</th>
                                <th>Part Code</th>
                                <th>Bin Numbers</th>
                                <th>Size</th>
                                <th>Min Stock Level</th>
                                <th>Max Stock Level</th>
                                <th>UOM</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((item, index) => (
                                <tr key={item.ID || index}>
                                    <td>{index + 1}</td>
                                    <td>{item.Product_Name}</td>
                                    <td>{item.Part_Code}</td>
                                    <td>{item.Bin_Location}</td>
                                    <td>{item.Size}</td>
                                    <td>{item.Min_Stock_Level}</td>
                                    <td>{item.Max_Stock_Level}</td>
                                    <td>{item.UOM}</td>
                                    <td style={{ padding: '5px' }}>
                                        <button onClick={() => handleEdit(item)}className="btn btn-custom-edit"style={{width: '5rem',border: '1px solid #502eff',backgroundColor: 'white',borderRadius: '5px',padding: '5px',fontSize: '14px',color: '#502eff',fontWeight: '700'}}> Edit</button>
                                        <button onClick={(e) => handleDelete(e, item.ID)}className="btn btn-custom-delete"style={{width: '6rem',border: '1px solid #ee5d50',backgroundColor: 'white',borderRadius: '5px',padding: '5px',marginLeft: '10px',color: '#ee5d50',fontSize: '14px',fontWeight: '700'}}> Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AddProduct;
